import { ISelectOption } from "./selectOption.interface";
import { FilterTypesEnum } from "../filters/filterTypes.enum";
import { SecurityRisk } from "../api/common";

export const SecurityRiskSelectOptions: ISelectOption[] = [
    {
        id: `${FilterTypesEnum.SecurityRisk.toString()}-${SecurityRisk.high}`,
        value: SecurityRisk.high,
        displayName: SecurityRisk.high,
        categoryName: FilterTypesEnum.SecurityRisk.toString(),
        filterType: FilterTypesEnum.SecurityRisk,
    },
    {
        id: `${FilterTypesEnum.SecurityRisk.toString()}-${SecurityRisk.medium}`,
        value: SecurityRisk.medium,
        displayName: SecurityRisk.medium,
        categoryName: FilterTypesEnum.SecurityRisk.toString(),
        filterType: FilterTypesEnum.SecurityRisk,
    },
    {
        id: `${FilterTypesEnum.SecurityRisk.toString()}-${SecurityRisk.low}`,
        value: SecurityRisk.low,
        displayName: SecurityRisk.low,
        categoryName: FilterTypesEnum.SecurityRisk.toString(),
        filterType: FilterTypesEnum.SecurityRisk,
    },
    {
        id: `${FilterTypesEnum.SecurityRisk.toString()}-${SecurityRisk.healthy}`,
        value: SecurityRisk.healthy,
        displayName: SecurityRisk.healthy,
        categoryName: FilterTypesEnum.SecurityRisk.toString(),
        filterType: FilterTypesEnum.SecurityRisk,
    },
];
